import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

const sortDesc = arr => [...arr].sort((a, b) => new Date(b.fecha) - new Date(a.fecha))

export function useGastos() {
  const [gastos, setGastos]   = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError]     = useState(null)

  useEffect(() => { fetchGastos() }, [])

  async function fetchGastos() {
    setLoading(true)
    const inicioMes = new Date()
    inicioMes.setDate(1)
    inicioMes.setHours(0, 0, 0, 0)

    const { data, error } = await supabase
      .from('gastos')
      .select('*')
      .gte('fecha', inicioMes.toISOString())
      .order('fecha', { ascending: false })

    if (error) setError(error)
    else setGastos(sortDesc(data))
    setLoading(false)
  }

  async function agregarGasto(gasto) {
    const { data: { user } } = await supabase.auth.getUser()
    const { data, error } = await supabase
      .from('gastos')
      .insert([{ ...gasto, user_id: user.id }])
      .select()
      .single()

    if (!error) {
      const inicioMes = new Date()
      inicioMes.setDate(1)
      inicioMes.setHours(0, 0, 0, 0)
      if (new Date(data.fecha) >= inicioMes) {
        setGastos(prev => sortDesc([data, ...prev]))
      }
    }
    return { data, error }
  }

  async function editarGasto(id, cambios) {
    const { data, error } = await supabase
      .from('gastos')
      .update(cambios)
      .eq('id', id)
      .select()
      .single()

    if (!error) setGastos(prev => sortDesc(prev.map(g => g.id === id ? data : g)))
    return { data, error }
  }

  async function eliminarGasto(id) {
    const { error } = await supabase.from('gastos').delete().eq('id', id)
    if (!error) setGastos(prev => prev.filter(g => g.id !== id))
    return { error }
  }

  const totales = gastos.reduce((acc, g) => {
    if (g.tipo === 'gasto')   acc.gastos   += g.monto
    if (g.tipo === 'ingreso') acc.ingresos += g.monto
    if (g.tipo === 'ahorro')  acc.ahorros  += g.monto
    return acc
  }, { gastos: 0, ingresos: 0, ahorros: 0 })

  return { gastos, loading, error, agregarGasto, editarGasto, eliminarGasto, totales, refetch: fetchGastos }
}
